import React from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { Session } from 'models';

import ChatHistoryHeader from '../ChatHistoryHeader';
import ChatHistoryList from '../ChatHistoryList';
import NewConversationButton from '../NewConversationButton';
import ChatAppOfflineWarning from '../../app/ChatAppOfflineWarning';

import { handleCreateNewConversation } from '../../app/ChatApp/actions_routing';
import { handleCloseApp } from '../../../app/App/actions';
import {
  getSingleChatId,
  getSingleChatEnabled,
  hasMoreThanOneActiveSession,
  getSortedOpenChatSessions,
} from '../../app/ChatApp/selectors';

import styles from './styles';

export const ChatHistory = ({
  handleClose,
  handleNewConversation,
  sessions,
  hasActiveSingleChat,
  hasMultipleActiveChats,
}) => {
  const wrapStyle = hasMultipleActiveChats ? styles.wrapNoCTA : styles.wrap;

  return (
    <div style={wrapStyle}>
      <ChatHistoryHeader onClose={handleClose} />
      <ChatHistoryList sessions={sessions} />
      <ChatAppOfflineWarning />
      <NewConversationButton
        onClick={handleNewConversation}
        hasActiveSingleChat={hasActiveSingleChat}
        hasMultipleActiveChats={hasMultipleActiveChats}
      />
    </div>
  );
};

ChatHistory.propTypes = {
  sessions: ImmutablePropTypes.orderedSetOf(React.PropTypes.instanceOf(Session)),
  handleClose: React.PropTypes.func,
  handleNewConversation: React.PropTypes.func,
  hasActiveSingleChat: React.PropTypes.bool,
  hasMultipleActiveChats: React.PropTypes.bool,
};

ChatHistory.defaultProps = {
  handleClose: () => {},
  handleNewConversation: () => {},
  sessions: Immutable.OrderedSet(),
  hasActiveSingleChat: false,
  hasMultipleActiveChats: false,
};

export const mapStateToProps = state => {
  return {
    sessions: getSortedOpenChatSessions(state),
    hasActiveSingleChat: getSingleChatEnabled(state) && Boolean(getSingleChatId(state)),
    hasMultipleActiveChats: getSingleChatEnabled(state) && hasMoreThanOneActiveSession(state),
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    handleClose() {
      dispatch(handleCloseApp());
    },
    handleNewConversation() {
      dispatch(handleCreateNewConversation());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatHistory);
